import { Outlet } from "react-router-dom";
import WorkspaceNav from "@/components/layout/WorkspaceNav";

export default function WorkspaceLayout() {
    return (
        <div className="relative min-h-screen flex flex-col md:flex-row">
            <WorkspaceNav />
            <main className="flex-1 relative z-10 min-w-0 md:ml-[240px]">
                <Outlet />
            </main>
        </div>
    );
}
